import { TooltipDesktop, UIHeading5 } from '@cian/ui-kit';
import cn from 'classnames';
import * as React from 'react';

import * as styles from './PromotionDescription.css';
import { PromotionTooltipContent } from './PromotionTooltipContent';
import { getPromotionVasList } from './utils/getPromotionVasList';
import { parsePromotionDescription } from './utils/parsePromotionDescription';
import { ETestId } from '../../constants';

interface IPromotionDescriptionProps {
  label?: string;
  className?: string;
  learnMoreUrl?: string;
}

export const PromotionDescription = ({ label, className, learnMoreUrl }: IPromotionDescriptionProps) => {
  if (!label?.trim()) {
    return null;
  }

  const promotionFlags = parsePromotionDescription(label);
  const items = getPromotionVasList(promotionFlags);
  const isTooltipVisible = items.length > 0;

  const content = (
    <div className={cn(styles['root'], className)} data-testid={ETestId.OfferCardPromotionLabels}>
      <UIHeading5 key={label} color="decorative-deeporange-vas">
        {label}
      </UIHeading5>
    </div>
  );

  if (!isTooltipVisible) {
    return content;
  }

  return (
    <div className={styles['wrapper']}>
      <TooltipDesktop
        theme="white"
        placement="top-start"
        title={
          <PromotionTooltipContent
            items={items}
            auctionBidRubles={promotionFlags.auctionBidRubles}
            learnMoreUrl={learnMoreUrl}
          />
        }
      >
        {content}
      </TooltipDesktop>
    </div>
  );
};
